import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, Chip, CircularProgress, Dialog, IconButton, Modal, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css'; 
import AdminEditor from './UsersEditor';
import UsersEditor from './UsersEditor';
import EmptyElement from 'elements/EmptyElement';
import { ApiRequest } from 'GlobalFunctions';

export default function UsersList(props: any) {

  const {
    company_id = null,
    is_popup = false
  } = props;

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {setLoading} = props;

  useEffect(() => {
    setLoading(false);
  }, [])
  
  const [user_list, setUserList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(1);
  const category = queryParams.get('category');
  const [refreshList, setRefreshList] = useState(0);

  const [openEditor, setOpenEditor] = useState(false);



  useEffect(() => {
    setLoading(true);
    loadList();
    
  }, [page])

  /*=========================================================
  LOAD LIST
  =========================================================*/
  const loadList = async () => {
    setLoading(true);

    // axios.get(ProjectConfig.api_url+"/users/list",
    // {
    //   headers: {
    //     'ltkn': localStorage.getItem('ltkn')
    //   },
    //   params: {
    //     page: page,
    //     role_id: 2,
    //     company_id: company_id
    //   }
    // })
    // .then((response) => {
    //     console.log("User List ",response.data); 
    //     setUserList(response.data.list)
    //     setTotalPages(response.data.total_pages)
    //     setLoading(false)
    // })
    // .catch((err) => {
    //   console.log(err.response.data);
    // })
    // .finally(() => {
    //   setLoading(false)
    // })

    await ApiRequest({
      url: "/users/list",
      method: "get",
      headers: {
        'ltkn': localStorage.getItem('ltkn')
      },
      query: {
        page: page,
        role_id: 2,
        company_id: company_id
      },
      setResponse: (response: any) => {
        console.log("User List ",response); 
        setUserList(response.list)
        setTotalPages(response.total_pages)
        setLoading(false)
      }
    })
    
    // localStorage.setItem('page', page.toString())
}


  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (user_id:number) => {
    setActiveItem(user_id)
    setOpenAlert(true)
  }



  const deleteItem = async () => {

    const body = new FormData();
    body.append("user_id", activeItem);

    await ApiRequest({
      url: "/users/delete",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar('Usuario eliminado con éxito', { variant: 'success' });
          loadList();
        }
        setOpenAlert(false);
      },
    });
  }
  

  /*=========================================================*/

// call global snackbar
  
const [openAlert, setOpenAlert] = useState(false);
const [activeItem, setActiveItem] = useState<any>(null);
const [openUnlinkAlert, setOpenUnlinkAlert] = useState(false);
const [unlinkItem, setUnlinkItem] = useState<any>(null);

const handleUnlink = (user_id: number) => {
  setUnlinkItem(user_id);
  setOpenUnlinkAlert(true);
};

const unlinkUser = async () => {
  await ApiRequest({
    url: "/users/unlinkCompany",
    method: "post",
    headers: { ltkn: localStorage.getItem("ltkn") },
    body: { user_id: unlinkItem },
    setResponse: (response: any) => {
      if (response.status === "success") {
        enqueueSnackbar('Usuario desvinculado de la empresa', { variant: 'success' });
        loadList();
      } else {
        enqueueSnackbar(response.message, { variant: 'error' });
      }
      setOpenUnlinkAlert(false);
    },
  });
};

  
  return (
      <div id='UsersList' className='ModuleContainer'>
        <div className="ModuleWrapper"> 
          <div className="boxContainerHeader">
            
            <div className="boxContainerTitle">
              <h2 className="h2_title">Usuarios</h2>
              <span className="h2_subtitle">Lista de usuarios registrados</span>
            </div>
            
            <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null)
                setOpenEditor(true)
              }}
              startIcon={<AddIcon />}
            >
              Crear Usuario
            </Button>

            </div>
            
          </div>

          <div id='UsersListIn'>
            
              <Box id='AdminList' className={!is_popup ? 'box100' : 'boxModal'}>

               {user_list.length !== 0? (
              <TableContainer>
              <Table aria-label="sticky table"> 
                <TableHead>
                  <TableRow>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>NOMBRE / EMAIL</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>TELÉFONO</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>ESTADO</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>ROLES</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>APP VERSION</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {user_list.map((user,i) => (
                      <TableRow 
                        
                        key={i}
                        hover
                        role="checkbox"
                      >
                        <TableCell>
                          <span className='flex_title'>{user.name} {user.last_name}</span>
                          <span className='flex_subtitle'>{user.email}</span>
                        </TableCell>

                      
                        <TableCell>
                          {user.phone}
                        </TableCell>

                        <TableCell>
                          <Chip label={user.is_active ? "Activo" : "Inactivo"} color={user.is_active ? "primary" : "error"} variant="outlined" size='small' />
                        </TableCell>

                        <TableCell>
                          {user.roles}
                        </TableCell>

                        <TableCell>
                          {user.app_version ? <Chip label={`v${user.app_version}`} size="small" sx={{ backgroundColor: '#e0e0e0', color: '#616161', fontWeight: 500, fontSize: '0.75rem' }} /> : '—'}
                        </TableCell>

                        <TableCell align="right">

                          <Button 
                            // component={Link}
                            // to={`edit/${user.user_id}`}
                            size="small"
                            variant="contained"
                            color="primary"
                            style={{"marginRight": "10px"}}
                            startIcon={<ModeEditIcon />}
                            onClick={() => {
                              setActiveItem(user.user_id)
                              setOpenEditor(true)
                            }}
                          >
                            Editar
                          </Button>


                          {localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2" &&
                          <IconButton aria-label="delete"  color="primary" onClick={() => handleDelete(user.user_id)}>
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                          }
                          <IconButton aria-label="unlink" color="warning" onClick={() => handleUnlink(user.user_id)} title="Desvincular de empresa">
                            <LinkOffIcon />
                          </IconButton>
                      </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            ) : (
              <div className="emptyList">
                <EmptyElement title="No hay usuarios registrados" subtitle="Empieza creando un nuevo usuario" />
              </div>
            )}
            
            {total_pages > 1 && (
            <Pagination 
              count={total_pages} 
              page={page}  
              onChange={(event, value) => {
                setPage(value)
                }} 
              color="primary"
              style={{"marginTop": "20px","alignSelf": "center"}}
            />
            )}
            </Box>
  
          </div>
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este usuario?"
            send={deleteItem}
        />

        <AlertDialog
            open={openUnlinkAlert}
            setOpen={setOpenUnlinkAlert}
            subtitle="¿Está seguro que desea desvincular este usuario de la empresa?"
            send={unlinkUser}
        />



        <UsersEditor
          setLoading={setLoading}
          openEditor={openEditor} 
          setOpenEditor={setOpenEditor}
          user_id={activeItem} 
          loadList={loadList}
          company_id={company_id}
        />



    </div>
  );
};